import { ADVERT_FORMAT_TYPES } from '@web-platform/shared-universal-constants/src/adverts';

import type {
  ConductorCreativeFlightsInlineBrandBannerFields,
  CreativeFlightsInlineBrandBanner,
} from '@web-platform/shared-universal-types/src/redux/acorn/state/flightsDayView/entitiesSearchResults/adverts/types';

export const getBrandBannerCreative = (
  fields: ConductorCreativeFlightsInlineBrandBannerFields,
): CreativeFlightsInlineBrandBanner => {
  const {
    appIndex,
    callToActionText,
    headline,
    hideSponsoredLabel,
    image,
    message,
    partner,
    partnerLogo,
    pioAgencyName,
    pioPartnerName,
    redirectUrl,
    splitTestId,
  } = fields;

  return {
    appIndex,
    callToActionText,
    headline,
    hideSponsoredLabel: hideSponsoredLabel === 'true',
    image,
    message,
    partner,
    partnerLogo,
    redirectUrl,
    format: ADVERT_FORMAT_TYPES.BRAND_BANNER,
    splitTestId,
    pioPartnerName,
    pioAgencyName,
  };
};
